<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qS4KWH/tc-custom/9781459216273.jpg?1718182738310" alt="This image is the cover for the book Proof of Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Proof of Life
      </h1>
      <p class="bookDescription body article font2">
        <p>CSI investigator Shanna Dawson has never forgiven herself for the long-ago disappearance of her little sister, Skylar. For fourteen years there have been no leads<i>or</i> proof of life. Until now. Until Skylar's fingerprints implicate her in a murder at a fraternity house. Shanna is desperate to find the young woman. And so is handsome campus cop Quinn Murphythe victim's half brother. But as their team investigation leads to an unexpected closeness and the revelation of family secrets, Shanna prays that her sister is innocent. <i>And</i> that the real killer is caught before Quinn is hurt, or Skylar is lost forever.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Scott
      </h2>
      
      <p class="authorDescription body article">Laura Scott is honored to write for the Love Inspired Suspense line, where a reader can find a heartwarming journey of faith amid the thrilling danger. A registred nurse by day and an author by night, she has more ideas than time to write! She lives with her husband of thirty-five years in Wauwatosa, Wisconsin. Visit Laura at www.laurascottbooks.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?114fa0de